import request from './request';

/**
 * Influencer Marketing Agent API — 达人营销模块
 */

// 达人状态映射
export const INFLUENCER_STATUS = {
  0: '待联系',
  1: '邮件已发送',
  2: '已回复',
  3: '合作中',
  4: '已完成',
  5: '已拒绝',
};

// 达人状态颜色
export const INFLUENCER_STATUS_COLOR = {
  0: 'default',
  1: 'processing',
  2: 'cyan',
  3: 'blue',
  4: 'success',
  5: 'error',
};

// Mock 达人数据 — 12条
const MOCK_INFLUENCERS = [
  { id: 1, name: '小美同学', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=xiaomei', category: '美妆', followers: 1280000, engagementRate: 4.8, region: '上海', tags: ['护肤', '彩妆', '测评'], status: 3, email: 'xiaomei@example.com' },
  { id: 2, name: '科技老王', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=wang', category: '科技', followers: 890000, engagementRate: 3.2, region: '北京', tags: ['数码', 'AI', '评测'], status: 1, email: 'wang@example.com' },
  { id: 3, name: '美食探店Lisa', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=lisa', category: '美食', followers: 2150000, engagementRate: 5.6, region: '广州', tags: ['探店', '测评', '短视频'], status: 4, email: 'lisa@example.com' },
  { id: 4, name: '穿搭日记Anna', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=anna', category: '时尚', followers: 560000, engagementRate: 6.1, region: '杭州', tags: ['穿搭', 'OOTD', '好物'], status: 2, email: 'anna@example.com' },
  { id: 5, name: '健身达人Mike', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=mike', category: '健身', followers: 340000, engagementRate: 7.2, region: '深圳', tags: ['健身', '减脂', '增肌'], status: 0, email: 'mike@example.com' },
  { id: 6, name: '旅行摄影师Kai', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=kai', category: '旅行', followers: 4200000, engagementRate: 3.9, region: '成都', tags: ['旅行', '摄影', 'Vlog'], status: 3, email: 'kai@example.com' },
  { id: 7, name: '宝妈好物推荐', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=ma', category: '母婴', followers: 780000, engagementRate: 5.3, region: '南京', tags: ['母婴', '好物', '育儿'], status: 1, email: 'ma@example.com' },
  { id: 8, name: '程序员小格', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=ge', category: '科技', followers: 150000, engagementRate: 8.5, region: '武汉', tags: ['编程', 'AI', '效率'], status: 0, email: 'ge@example.com' },
  { id: 9, name: '萌宠日记', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=pet', category: '宠物', followers: 2800000, engagementRate: 6.7, region: '重庆', tags: ['萌宠', '猫', '狗'], status: 5, email: 'pet@example.com' },
  { id: 10, name: '家居改造王', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=home', category: '家居', followers: 430000, engagementRate: 4.1, region: '苏州', tags: ['家居', '装修', '收纳'], status: 4, email: 'home@example.com' },
  { id: 11, name: '二次元少女Mio', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=mio', category: '二次元', followers: 1950000, engagementRate: 7.8, region: '上海', tags: ['Cosplay', '动漫', '手办'], status: 2, email: 'mio@example.com' },
  { id: 12, name: '职场导师老张', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=zhang', category: '职场', followers: 670000, engagementRate: 3.6, region: '北京', tags: ['职场', '面试', '副业'], status: 3, email: 'zhang@example.com' },
];

// Mock 活动数据
const MOCK_CAMPAIGNS = [
  { id: 1, influencerId: 1, influencerName: '小美同学', product: '清透精华水', status: 3, startDate: '2026-07-01', endDate: '2026-08-01', fee: 15000, impressions: 250000, clicks: 12000, conversions: 380 },
  { id: 2, influencerId: 2, influencerName: '科技老王', product: '智能手表Pro', status: 1, startDate: '2026-07-15', endDate: '2026-08-15', fee: 22000, impressions: 0, clicks: 0, conversions: 0 },
  { id: 3, influencerId: 3, influencerName: '美食探店Lisa', product: '鲜味酱油', status: 4, startDate: '2026-06-01', endDate: '2026-06-30', fee: 35000, impressions: 890000, clicks: 45000, conversions: 1200 },
  { id: 4, influencerId: 4, influencerName: '穿搭日记Anna', product: '夏装连衣裙', status: 2, startDate: '2026-07-20', endDate: '2026-08-20', fee: 8000, impressions: 0, clicks: 0, conversions: 0 },
  { id: 5, influencerId: 6, influencerName: '旅行摄影师Kai', product: '户外背包', status: 3, startDate: '2026-07-10', endDate: '2026-08-10', fee: 48000, impressions: 1200000, clicks: 60000, conversions: 890 },
  { id: 6, influencerId: 11, influencerName: '二次元少女Mio', product: '联名手办', status: 2, startDate: '2026-07-25', endDate: '2026-08-25', fee: 28000, impressions: 0, clicks: 0, conversions: 0 },
];

// 模拟延迟
const delay = (ms = 300) => new Promise((r) => setTimeout(r, ms));

export const influencerAPI = {
  /** 获取达人列表(支持筛选) */
  search: async (params = {}) => {
    await delay();
    let result = [...MOCK_INFLUENCERS];
    if (params.category) result = result.filter((i) => i.category === params.category);
    if (params.region) result = result.filter((i) => i.region === params.region);
    if (params.minFollowers) result = result.filter((i) => i.followers >= params.minFollowers);
    if (params.maxFollowers) result = result.filter((i) => i.followers <= params.maxFollowers);
    if (params.minEngagement) result = result.filter((i) => i.engagementRate >= params.minEngagement);
    if (params.keyword) result = result.filter((i) => i.name.includes(params.keyword) || i.tags.some((t) => t.includes(params.keyword)));
    return result;
  },

  /** 获取达人详情 */
  getById: async (id) => {
    await delay();
    return MOCK_INFLUENCERS.find((i) => i.id === Number(id)) || null;
  },

  /** 生成邀约邮件 */
  generateEmail: async (influencerId, product, tone) => {
    await delay(500);
    const inf = MOCK_INFLUENCERS.find((i) => i.id === Number(influencerId));
    const toneMap = {
      formal: `尊敬的${inf?.name}您好：\n\n我是西蒙的猫品牌方负责人，长期关注您在${inf?.category}领域的优质内容创作。您的粉丝群体与我们的品牌受众高度契合，希望能邀请您合作推广「${product}」。\n\n合作细节：\n- 合作形式：产品测评+原创内容\n- 发布平台：小红书/抖音\n- 合作费用：具体面议\n\n期待您的回复，如有意向请联系我们。\n\n此致\n敬礼\n西蒙的猫品牌团队`,
      friendly: `嗨${inf?.name}！我是西蒙的猫的小编为，一直有关注你的内容~超喜欢你在${inf?.category}方向的分享！\n\n我们最近在推一款新品「${product}」，觉得和你的内容风格特别搭！想邀请你来合作推广，可以吗？\n\n合作方式我们可以灵活沟通～有兴趣的话随时联系我呀！\n\n— 西蒙的猫团队`,
      creative: `🌟 ${inf?.name}，你被选中啦！🌟\n\n西蒙的猫正在寻找「${product}」的首席体验官，而你就是我们要找的那个人！\n\n🔥 为什么是你在？\n- 你在${inf?.category}领域的影响力有目共睹\n- 你的内容质量是我们见过最棒的\n- 你的粉丝和我们的用户完美匹配\n\n来一场有趣的碰撞吧！期待你的加入～\n\n— 西蒙的猫 🐱`,
    };
    return { content: toneMap[tone] || toneMap.friendly };
  },

  /** 发送邮件 */
  sendEmail: async (influencerId) => {
    await delay(400);
    const inf = MOCK_INFLUENCERS.find((i) => i.id === Number(influencerId));
    if (inf) inf.status = 1;
    return { success: true, message: `邮件已发送至${inf?.name}` };
  },

  /** 获取活动列表 */
  getCampaigns: async () => {
    await delay();
    return MOCK_CAMPAIGNS;
  },

  /** 获取效果统计数据 */
  getStats: async () => {
    await delay();
    return {
      monthlyCampaigns: [
        { month: '1月', count: 2 },
        { month: '2月', count: 3 },
        { month: '3月', count: 5 },
        { month: '4月', count: 4 },
        { month: '5月', count: 7 },
        { month: '6月', count: 6 },
        { month: '7月', count: 8 },
      ],
      engagementDistribution: [
        { name: '3%-4%', value: 25 },
        { name: '4%-5%', value: 35 },
        { name: '5%-6%', value: 20 },
        { name: '6%-7%', value: 12 },
        { name: '7%+', value: 8 },
      ],
      totalSpent: 156000,
      totalROI: 3.2,
      avgEngagement: 5.4,
    };
  },

  /** 品类列表 */
  getCategories: async () => {
    await delay(100);
    return ['美妆', '科技', '美食', '时尚', '健身', '旅行', '母婴', '宠物', '家居', '二次元', '职场'];
  },

  /** 地区列表 */
  getRegions: async () => {
    await delay(100);
    return ['北京', '上海', '广州', '深圳', '杭州', '成都', '武汉', '南京', '重庆', '苏州'];
  },
};

export default influencerAPI;
